import { Language } from '@lemon8/web-app-shared/i18n';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';

import EN from './en.png';
import JA from './ja.png';
import ID from './id.png';
import MS from './ms.png';
import TH from './th.png';
import VI from './vi.png';

const BUBBLE_MAP: { [key in Language]: string } = {
  [Language.en]: EN,
  [Language.id]: ID,
  [Language.ja]: JA,
  [Language.ms]: MS,
  [Language.th]: TH,
  [Language.vi]: VI,
  [Language.fil]: EN,
  [Language.fr]: EN,
};

export const useBubbleSrc = (): string => {
  const { language } = useAtomValue($Locale);
  return BUBBLE_MAP[language];
};
